// Shared JS for the "advertorial_offer_1" page template.
$(document).ready(function(){

    var $progressFill = $('.adv1_progress-bar-fill');
    if ($progressFill.length) {
        function updateProgress() {
            var scrollTop = window.scrollY || document.documentElement.scrollTop;
            var docHeight = document.documentElement.scrollHeight - window.innerHeight;
            var percent = docHeight > 0 ? (scrollTop / docHeight) * 100 : 0;
            $progressFill.css('width', percent + '%');
        }

        updateProgress();
        window.addEventListener('scroll', updateProgress, { passive: true });
        window.addEventListener('resize', updateProgress);
    }

    // Every CTA button in the advertorial scrolls to the product title
    // on this same page instead of navigating away.
    var $productSection = $('.main_product-outer').first();
    var $scrollTarget = $('.main_product-title').first();
    if (!$scrollTarget.length) {
        $scrollTarget = $productSection;
    }

    if ($scrollTarget.length) {
        $('.adv1_cta-button, .adv1_final-offer-button, .adv1_sticky-cta-button').on('click', function(e){
            e.preventDefault();
            $('html, body').animate({
                scrollTop: $scrollTarget.offset().top - 20
            }, 600);
        });
    }

    // Slide the sticky mobile CTA off-screen whenever the customer has
    // scrolled to any product block on the page (there can be more than
    // one - the embedded one inside the advertorial and the standalone
    // one below it), so it doesn't sit on top of the actual ATC widget.
    var $stickyCta = $('.adv1_sticky-cta');
    var $productSections = $('.main_product-outer');
    if ($stickyCta.length && $productSections.length && 'IntersectionObserver' in window) {
        var intersectingStates = new Map();
        var stickyObserver = new IntersectionObserver(function(entries){
            entries.forEach(function(entry){
                intersectingStates.set(entry.target, entry.isIntersecting);
            });
            var anyIntersecting = Array.from(intersectingStates.values()).some(function(state){
                return state;
            });
            $stickyCta.toggleClass('adv1_sticky-cta--hidden', anyIntersecting);
        }, { threshold: 0.1 });
        $productSections.each(function(){
            stickyObserver.observe(this);
        });
    }

});
